export default "__VITE_ASSET__CgXIixk0__"